import React from 'react'
import * as Yup from 'yup'
import { get, keyBy } from 'lodash'
import { Field, Formik, Form } from 'formik'
import styled from 'styled-components'
import { Text, Row, Column, FormikInput, Button, Icon, FlexContainer } from '../../common'
import { withAWSAuth } from '../../../hoc'
import AuthWrapper, { RequestErrorWrapper } from '../../layouts/Auth/Auth.wrapper'

const ValidationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'form.validations.min_length')
    .max(20, 'form.validations.max_length')
    .matches(/\d/, 'form.validations.one_number')
    .matches(/[A-Z]/, 'form.validations.one_upper_caps')
    .required('form.validations.required'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'form.validations.password_match')
    .required('form.validations.required')
})

const PASSWORD_VALIDATIONS = keyBy([
  { key: 'form.validations.min_length', validation: (value) => String(value).length >= 8 },
  { key: 'form.validations.max_length', validation: (value) => String(value).length <= 20 },
  { key: 'form.validations.one_number', validation: (value) => new RegExp(/\d/).test(value) },
  { key: 'form.validations.one_upper_caps', validation: (value) => new RegExp(/[A-Z]/).test(value) },
  { key: 'form.validations.required', validation: (value) => !['undefined', 'null'].includes(typeof value) }
], 'key')

const renderChecked = (key, value) => {
  if (value.length <= 0) return null
  return get(PASSWORD_VALIDATIONS, key).validation(value) ? <Icon name='check' color='#4cb358' right={5} /> : <Icon name='cross' color='#db5959' right={5} />
}

const validationTextColor = (key, value) => {
  if (value.length <= 0) return '#333333'
  return get(PASSWORD_VALIDATIONS, key).validation(value) ? '#4cb358' : '#db5959'
}

const PasswordValidation = ({ value }) => {
  return (
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>{renderChecked('form.validations.min_length', value)}<Text color={validationTextColor('form.validations.min_length', value)} text='form.validations.min_length' size={12} /></li>
      <li>{renderChecked('form.validations.one_number', value)} <Text color={validationTextColor('form.validations.one_number', value)} text='form.validations.one_number' size={12} /></li>
      <li>{renderChecked('form.validations.one_upper_caps', value)} <Text color={validationTextColor('form.validations.one_upper_caps', value)} text='form.validations.one_upper_caps' size={12} /></li>
    </ul>
  )
}

const FormContainer = styled(FlexContainer)``

const UpdatePasswordDisplayForm = ({ errors, dirty, isSubmitting, handleSubmit, handleChange, handleReset, submitCount, values, isValid, ...props }) => (
  (
    <Form onSubmit={handleSubmit} onReset={handleReset} autoComplete='off'>
      <FormContainer direction='column'>
        <Row>
          <Column justify='flex-end'>
            <Text text='form.complete_signup.subtitle' style={{ fontSize: '12px', margin: '10px 0px' }} strong />
          </Column>
        </Row>
        <Row>
          <Column justify='flex-end'>
            <PasswordValidation value={get(values, 'password', '')} />
          </Column>
        </Row>
        <Row>
          <Column>
            <Field
              style={{ padding: 0, margin: '7px 0' }}
              component={FormikInput}
              name='newPassword'
              type='password'
              label='Nueva clave'
              hasFeedback
              placeholder='*******'
              disabled={isSubmitting}
              allowClear
              submitCount={submitCount}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <Field
              style={{ padding: 0, margin: '7px 0' }}
              component={FormikInput}
              name='passwordConfirm'
              type='password'
              label='Reingresar nueva clave'
              hasFeedback
              placeholder='*******'
              disabled={isSubmitting}
              allowClear
              submitCount={submitCount}
            />
          </Column>
        </Row>
        {errors && errors['response'] !== undefined && <Row>
          <Column>
            <RequestErrorWrapper>
              <Text text={errors['response']} />
            </RequestErrorWrapper>
          </Column>
        </Row>}
        <Row style={{ margin: '15px 0px' }}>
          <Column>
            <Button type='submit' className='login-form-button' disabled={isSubmitting || !isValid} loading={isSubmitting} text='form.update_password.btn.submit' />
          </Column>
        </Row>
      </FormContainer >
    </Form>
  )
)

const UpdatePasswordRequestForm = ({ handleSubmit, handleReset, initialValues, isSubmitting }) => (
  <Formik
    onSubmit={handleSubmit}
    onReset={handleReset}
    initialValues={initialValues}
    validationSchema={ValidationSchema}
    render={UpdatePasswordDisplayForm}
    enableReinitialize
  />
)

class UpdatePasswordRequest extends React.Component {
  static async getInitialProps ({ query }) {
    const currentUsername = get(query, 'u')
    return { currentUsername }
  }
  handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const { awsAuth, credentials } = this.props
    const { username, password } = credentials
    const { newPassword } = values
    setSubmitting(true)
    awsAuth.completeNewPassword(username, password, newPassword)
      .then((resp) => window.location.reload())
      .catch((err) => {
        const errorCode = get(err, 'code')
        setFieldError('response', `form.auth.error.${errorCode}`)
        setSubmitting(false)
      })
  }
  render () {
    return (

      <AuthWrapper >
        <UpdatePasswordRequestForm handleSubmit={this.handleSubmit} initialValues={{ newPassword: '', passwordConfirm: '' }} />
      </AuthWrapper>
    )
  }
}

UpdatePasswordRequest.propTypes = {

}

export default withAWSAuth(UpdatePasswordRequest)
